/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-extraneous-dependencies */
import { Breadcrumb, Button, Card, Input, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined } from '@ant-design/icons';
import {
	deleteLocationWiseFare,
	getAllLocationsWiseFarePaged,
	updateLocationWiseFare,
} from '../../redux/LocationWiseFareSlice';

import { style } from '../../Styles';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import LocationWiseFareDrawer from './LocationWiseFareDrawer';
import ActionButton from './ActionButton';

const LocationWiseFare = ({ role }) => {
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('id');
	const [sortDirection, setSortDirection] = useState('ASC');
	const { Settings } = useSelector((state) => state.settings);
	const currencyRender = () => {
		return <span>{Settings?.settingsData?.currency || '€'}</span>;
	};

	const LocationWiseFareColumns = [
		{
			title: 'ID',
			dataIndex: 'id',
			sorter: true,
		},
		{
			title: 'Source Location',
			key: 'sourceLocation',
			render: (record) => {
				return <span>{`${record?.sourceLocation?.locationName} `}</span>;
			},
			sorter: true,
		},
		{
			title: 'Destination Location',
			key: 'destinationLocation',
			render: (record) => {
				return <span>{`${record?.destinationLocation?.locationName} `}</span>;
			},
			sorter: true,
		},
		{
			title: 'Flat Fare',
			key: 'flatFare',
			render: (record) => {
				return (
					<span>
						{currencyRender() || '€'} {`${record?.flatFare} `}
					</span>

				);
			},
			sorter: true,
		},
		{
			title: 'Vehicle Type',
			key: 'vehicleType',
			render: (record) => {
				return <span style={style.tags}>{`${record?.vehicleType?.vehicleType} `}</span>;
			},
			sorter: true,
		},
		{
			title: 'Status',
			key: 'isActive',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record.isActive ? (
							<div style={style.statusActif}>ACTIVE</div>
						) : (
							<div style={style.statusInactif}>INACTIVE</div>
						)}
					</span>
				);
			},
			sorter: true,
			width: 90,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (record) => (
				<ActionButton
					record={record}
					onDelete={onDelete}
					onRowClick={onRowClick}
					onChangeStatus={onChangeStatus}
				/>
			),
			disabled: !role?.includes('SUPER_ADMIN'),
		},
	];
	const [makingApiCall, setMakingApiCall] = useState(false);
	const dispatch = useDispatch();
	const { LocationsWiseFare } = useSelector((state) => state.locationsWiseFare);
	const [locationWiseFare, setLocationWiseFare] = useState(null);
	const [showDrwer, setShowDrwer] = useState(false);

	const onDelete = (id) => {
		setMakingApiCall(true);
		dispatch(deleteLocationWiseFare({ id }))
			.unwrap()
			.then(() => {
				message.success('Location wise Fare deleted successfully');
				fetchAllLocationsWiseFare();
			})
			.catch(() => {
				message.error('Could not delete Locationwise Fare, please try again');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const onChangeStatus = (values) => {
		setMakingApiCall(true);
		dispatch(updateLocationWiseFare({ id: values.id, locationWiseFare: values }))
			.unwrap()
			.then(() => {
				message.success('Locationwise Fare saved successfully');
			})
			.catch((e) => {
				if (e.message === 'LOCATION_WISE_FARE_ALREADY_EXISTS') {
					message.error('Locationwise Fare already exists');
				} else {
					message.error('Could not save Locationwise Fare, please try again');
				}
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('id');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	const handleOpenDrawer = () => {
		setShowDrwer(true);
	};
	const handleCloseDrawer = () => {
		setLocationWiseFare(null);
		setShowDrwer(false);
	};
	const fetchAllLocationsWiseFare = async () => {
		setMakingApiCall(true);
		dispatch(getAllLocationsWiseFarePaged({ page: currentPage - 1, size: pageSize, sortBy, sortDirection, search }))
			.unwrap()
			.then(() => { })
			.catch(() => {
				message.error('Could not fetch Locationwise Fare, please try again');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};
	useEffect(() => {
		fetchAllLocationsWiseFare();
	}, [currentPage, pageSize, sortBy, sortDirection, search]);

	const onRowClick = (record) => {
		setLocationWiseFare(record);
		handleOpenDrawer();
	};

	const data = LocationsWiseFare.locationsWiseFareList.map((item) => ({ ...item, key: item.id }));
	return (
		<>
			<Card
				style={{
					margin: 16,
					maxHeight: '90%', // Set maximum width
					height: 'auto', // Allow width to be dynamic
				}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Locations',
								},
								{
									title: 'Locationwise Fare',
								},
							]}
						/>
						<Button
							type='default'
							size='small'
							// style={{ margin: '0 8px 8px 0' }}
							onClick={() => fetchAllLocationsWiseFare()}>
							<ReloadOutlined />
						</Button>
					</div>

					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Input.Search
							placeholder='Search'
							style={{ margin: '0 8px 8px 0' }}
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
						{role?.includes('SUPER_ADMIN') && (
							<Button
								type='default'
								style={{ float: 'right', marginBottom: 8 }}
								onClick={handleOpenDrawer}>
								Add Locationwise Fare
							</Button>
						)}
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={makingApiCall}
					columns={LocationWiseFareColumns.filter((item) => {
						return !item.disabled;
					})}
					dataArray={data}
					handleDoubleClickRow={(record) => (role?.includes('SUPER_ADMIN') ? onRowClick(record) : {})}
					handleSelectedRow={() => { }}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: LocationsWiseFare.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>
			{showDrwer && (
				<LocationWiseFareDrawer
					handleClose={handleCloseDrawer}
					open={handleOpenDrawer}
					locationWiseFareId={locationWiseFare?.id}
				/>
			)}
		</>
	);
};

export default LocationWiseFare;
